import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: calc(100vh - 40px);

  .contentContainer {
    width: 100%;
    /* permite a coluna encolher abaixo da largura intrinseca da tabela;
       sem isso a tabela larga empurra o layout e vaza a direita (ex: zoom 125%) */
    min-width: 0;
  }

  .dashboardContent {
    background-color: ${({ theme }) => theme.colors.background.gray};

    height: 100%;
    width: 100%;
    padding: 40px;

    overflow-y: scroll;

    @media (max-width: 900px) {
      padding: 24px 20px;
    }
  }
`;
